<template>
	<div class="table-card">
		<table class="table table--default" v-if="schedulesData?.length">
			<thead class="table__head">
			<tr class="table__row">
				<td class="table__col">№</td>
				<td class="table__col">Товарные категории</td>
				<td class="table__col">Ответственный<br>МОЗ</td>
				<td class="table__col">Ответственный<br>УК</td>
				<td class="table__col">Ответственный<br>КМ</td>
				<td class="table__col">Переодичность</td>
				<td class="table__col">Даты</td>
				<td class="table__col"></td>
			</tr>
			<tr class="table__margin">
				<td colspan="100%"></td>
			</tr>
			</thead>
			<tbody class="table__body">
				<SchedulesTableRow v-for="tender in schedulesData" :key="tender.id" :tender="tender"/>
			</tbody>
		</table>
		<div v-else class="table-card__empty">Графики не найдены</div>
	</div>

</template>

<script>
// import {mapActions, mapGetters} from "vuex";

import SchedulesTableRow from "@/components/sections/Schedules/SchedulesTableRow.vue";

export default {
	name: "SchedulesTable",
	components: {SchedulesTableRow},
	props: {
			schedulesData: {
			type: Array,
			required: true
		}
	},
	data: () => {
		return {
		}
	}

}
</script>


